module.exports = __webpack_public_path__ + "static/img/huaweiP10.72dc2b83.png";